class ChannelTalkService {
  constructor() {
    this.loadScript();
  }

  loadScript() {
    var w = window;
    if (w.ChannelIO) {
      return (window.console.error || window.console.log || function(){})('ChannelIO script included twice.');
    }
    var ch = function() {
      ch.c(arguments);
    };
    ch.q = [];
    ch.c = function(args) {
      ch.q.push(args);
    };
    w.ChannelIO = ch;
    function l() {
      if (w.ChannelIOInitialized) {
        return;
      }
      w.ChannelIOInitialized = true;
      var s = document.createElement('script');
      s.type = 'text/javascript';
      s.async = true;
      s.src = 'https://cdn.channel.io/plugin/ch-plugin-web.js';

      s.charset = 'UTF-8';
      s.setAttribute('nance','dCohhbYqxhNl92Wz8gKcTRYLw0UDNqHovQMdfM63w5XA2fk3m0jcoYKPrjBFSa2')
      var x = document.getElementsByTagName('script')[0];
      x.parentNode.insertBefore(s, x);
    }
    if (document.readyState === 'complete') {
      l();
    } else if (window.attachEvent) {
      window.attachEvent('onload', l);
    } else {
      window.addEventListener('DOMContentLoaded', l, false);
      window.addEventListener('load', l, false);
    }
  }

  boot(settings, callback) {
    window.ChannelIO('boot', settings, callback);
  }

  show(){
    window.ChannelIO('show');
  }

  updateUser(name,email){
    window.ChannelIO('updateUser', {
      profile: {
        email: email,
        name: name,
      },
    }, function onUpdateUser(error, user) {
      if (error) {
        console.error(error)
      } else {
        console.log('updateUser success', user)
      }
    })
  }

  shutdown() {
    window.ChannelIO('shutdown');
  }

  onHide(callback){
    window.ChannelIO('onHide', function() {
      callback();
    });
  }

  onClickRedirect(callback){
    window.ChannelIO('onClickRedirect', function(url) {
      callback(url);
    });
  }

  onShow(callback){
    window.ChannelIO('onShow', function() {
      callback();
    });
  }

  // onChangeBadge(callback){
  //   window.ChannelIO('onChangeBadge', function(unreadCount) {
  //     callback(unreadCount);
  //   });
  // }
}

export default new ChannelTalkService();